module.exports = __webpack_public_path__ + "img/win_icon.38856358.svg";